/* IOC · Wholesale portal (sections/ioc-wholesale-portal.liquid).
   Order form: steppers, live count and price summary, the 90 / multiple-of-45 rule, and Send to the Vercel function.
   Application form: EIN and business details to /api/apply, inline errors, the backend re-checks everything.
   Prices shown here are for the customer's eyes only; the function recomputes every price server-side. */
(function () {
  'use strict';

  function money(cents, sym) {
    return (sym || '$') + (Math.round(cents) / 100).toFixed(2);
  }

  // Same wording as lib/core.js checkCount in the backend.
  function rule(total, min, cs) {
    if (total <= 0) return { ok: false, msg: 'Pick your flavors. Orders start at ' + min + ' cookies.' };
    if (total < min) return { ok: false, msg: 'Add ' + (min - total) + ' more to reach the ' + min + '-cookie minimum.' };
    var rem = total % cs;
    if (rem !== 0) {
      var need = cs - rem;
      return { ok: false, msg: total - rem >= min ? 'Add ' + need + ' more to fill a case, or take ' + rem + ' out.' : 'Add ' + need + ' more to fill a case.' };
    }
    return { ok: true, msg: total + ' cookies, ' + total / cs + (total / cs === 1 ? ' full case' : ' full cases') + '. Ready to send.' };
  }

  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      if (val === null) localStorage.removeItem(key);
      else localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  function ref() {
    var a = '';
    for (var i = 0; i < 12; i++) a += 'abcdefghijkmnpqrstuvwxyz23456789'.charAt(Math.floor(Math.random() * 32));
    return a;
  }

  function init(form) {
    if (form.__whp) return;
    form.__whp = true;
    var d = form.dataset;
    var min = parseInt(d.min, 10) || 90;
    var cs = parseInt(d.case, 10) || 45;
    var step = parseInt(d.step, 10) || 5;
    var sym = d.sym || '$';
    var key = d.storeKey || 'ioc-whp';
    var canSend = !!(d.endpoint && d.sig && d.catalog);
    var sample = d.sample === '1';
    var root = form.closest('[data-ioc-whp]') || document;
    var items = Array.prototype.slice.call(form.querySelectorAll('[data-whp-item]'));
    var send = form.querySelector('[data-whp-send]');
    var ruleEl = form.querySelector('[data-whp-rule]');
    var linesEl = form.querySelector('[data-whp-lines]');
    var subEl = form.querySelector('[data-whp-subtotal]');
    var totalEl = form.querySelector('[data-whp-total]');
    var meter = form.querySelector('[data-whp-meter]');
    var note = form.querySelector('[data-whp-note]');
    var result = form.querySelector('[data-whp-result]');
    var barN = form.querySelector('[data-whp-bar-n]');
    var barSub = form.querySelector('[data-whp-bar-sub]');
    var barMsg = form.querySelector('[data-whp-bar-msg]');
    var sentEl = root.querySelector('[data-whp-sent]');
    var busy = false;

    function qtyOf(item) {
      var n = parseInt(item.querySelector('[data-whp-qty]').value, 10);
      return isFinite(n) && n > 0 ? Math.min(n, 20000) : 0;
    }

    function update(save) {
      var total = 0, sub = 0, rows = [];
      items.forEach(function (item) {
        var q = qtyOf(item);
        var p = parseInt(item.dataset.price, 10) || 0;
        item.classList.toggle('has-qty', q > 0);
        if (q > 0) {
          total += q;
          sub += q * p;
          rows.push('<li><span>' + escapeHtml(item.dataset.name) + '</span><span class="l-q">' + q + ' x ' + money(p, sym) + ' = ' + money(q * p, sym) + '</span></li>');
        }
      });
      var r = rule(total, min, cs);
      totalEl.textContent = total;
      subEl.textContent = money(sub, sym);
      linesEl.innerHTML = rows.join('');
      ruleEl.textContent = r.msg;
      ruleEl.classList.toggle('is-ok', r.ok);
      if (meter) {
        var goal = total < min ? min : Math.ceil(total / cs) * cs;
        meter.style.width = Math.min(100, goal ? (total / goal) * 100 : 0) + '%';
        meter.parentNode.classList.toggle('is-ok', r.ok);
      }
      if (barN) { barN.textContent = total; barSub.textContent = money(sub, sym); barMsg.textContent = r.ok ? 'Ready to send.' : r.msg; }
      send.disabled = busy || !r.ok || (!canSend && !sample);
      if (save) {
        var picks = {};
        items.forEach(function (item) { var q = qtyOf(item); if (q) picks[item.dataset.h] = q; });
        store(key + ':draft', { picks: picks, note: note ? note.value : '' });
      }
      return { total: total, sub: sub, ok: r.ok };
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    }

    function showResult(kind, title, text) {
      result.hidden = false;
      result.className = 'whp-result' + (kind ? ' is-' + kind : '');
      result.innerHTML = '<b>' + escapeHtml(title) + '</b>' + escapeHtml(text);
      try { result.focus({ preventScroll: false }); } catch (e) { result.focus(); }
    }

    function showSent() {
      var last = store(key + ':sent');
      if (!sentEl || !last || !last.at) return;
      var when = new Date(last.at);
      sentEl.textContent = 'Sent from this page on ' + when.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) + ': ' + last.total + ' cookies' + (last.reference ? ' (' + last.reference + ')' : '') + '. Waiting on Nick to confirm shipping and email the invoice.';
      sentEl.hidden = false;
    }

    // Restore picks from this browser (a reload for a stale page keeps the order).
    var saved = store(key + ':draft');
    if (saved && saved.picks) {
      items.forEach(function (item) { var q = saved.picks[item.dataset.h]; if (q) item.querySelector('[data-whp-qty]').value = q; });
      if (note && saved.note) note.value = saved.note;
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-whp-inc],[data-whp-dec]');
      if (!btn) return;
      var item = btn.closest('[data-whp-item]');
      var input = item.querySelector('[data-whp-qty]');
      var q = qtyOf(item);
      q = btn.hasAttribute('data-whp-inc') ? q + step : Math.max(0, q - step);
      input.value = q;
      update(true);
    });
    form.addEventListener('input', function (e) {
      if (e.target.matches('[data-whp-qty],[data-whp-note]')) update(true);
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-whp-qty]')) { e.target.value = qtyOf(e.target.closest('[data-whp-item]')); update(true); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var now = update(false);
      if (!now.ok || busy) return;
      if (sample || !canSend) {
        showResult('test', 'Sample only.', ' This is the sample page, so nothing was sent. The real page sends ' + now.total + ' cookies to Nick as a draft order.');
        return;
      }
      var lines = [];
      items.forEach(function (item) { var q = qtyOf(item); if (q) lines.push({ h: item.dataset.h, q: q }); });
      var payload = {
        customerId: d.customer, email: d.email, ts: d.ts, sig: d.sig,
        catalog: d.catalog, catalogSig: d.catalogSig,
        lines: lines, note: note ? note.value : '', ref: ref()
      };
      busy = true;
      send.disabled = true;
      var label = send.textContent;
      send.textContent = 'Sending...';
      fetch(d.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (res) { return res.json().catch(function () { return { ok: false, message: 'The order desk did not answer. Nothing was sent.' }; }); })
        .then(function (out) {
          if (out && out.ok && out.dryRun) {
            showResult('test', 'Not sent yet.', ' ' + out.message);
          } else if (out && out.ok) {
            showResult('', 'Sent.', ' ' + out.message + (out.reference ? ' Reference ' + out.reference + '.' : ''));
            store(key + ':sent', { at: new Date().toISOString(), total: out.summary ? out.summary.totalQty : now.total, reference: out.reference || '' });
            store(key + ':draft', null);
            items.forEach(function (item) { item.querySelector('[data-whp-qty]').value = 0; });
            if (note) note.value = '';
            showSent();
          } else {
            showResult('err', 'Not sent.', ' ' + ((out && out.message) || 'Something went wrong. Nothing was sent.'));
          }
        })
        .catch(function () {
          showResult('err', 'Not sent.', ' We could not reach the order desk. Check your connection and try again, or email the bakery.');
        })
        .then(function () {
          busy = false;
          send.textContent = label;
          update(false);
        });
    });

    showSent();
    update(false);
  }

  // ---------- the EIN application form ----------
  // Same field names as the backend (and Sweet Addison's intake). Checks run here for speed; the backend repeats
  // every check and is the one that counts.
  var EIN_RE = /^\s*\d{2}-?\d{7}\s*$/;
  var MSG = {
    legal_name: 'Enter your legal business name.',
    entity_type: 'Pick your business entity type.',
    ein_missing: 'Enter your EIN. It\'s 9 digits, like 12-3456789.',
    ein_bad: 'That EIN isn\'t 9 digits. Use 12-3456789 or 123456789.',
    name: 'Enter a contact name.',
    email: 'Enter a valid email.',
    phone: 'Enter a phone number with area code.',
    address1: 'Enter the street address.',
    city: 'Enter the city.',
    state: 'Enter the state.',
    zip: 'Enter a 5-digit ZIP code.'
  };

  function initApply(form) {
    if (form.__whpAp) return;
    form.__whpAp = true;
    var d = form.dataset;
    var result = form.querySelector('[data-whp-ap-result]');
    var btn = form.querySelector('.whp-ap-send');

    function val(name) { var el = form.elements[name]; return el ? String(el.value || '').trim() : ''; }
    function setErr(name, msg) {
      var el = form.elements[name];
      var err = form.querySelector('[data-err-for="' + name + '"]');
      if (el) { if (msg) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); }
      if (err) { err.textContent = msg || ''; err.hidden = !msg; }
    }
    function check() {
      var e = {};
      if (!val('legal_name')) e.legal_name = MSG.legal_name;
      if (!val('entity_type')) e.entity_type = MSG.entity_type;
      if (!val('ein')) e.ein = MSG.ein_missing; else if (!EIN_RE.test(val('ein'))) e.ein = MSG.ein_bad;
      if (!val('name')) e.name = MSG.name;
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('email'))) e.email = MSG.email;
      var pd = val('phone').replace(/\D/g, '');
      if (pd.length < 10 || pd.length > 15) e.phone = MSG.phone;
      if (!val('address1')) e.address1 = MSG.address1;
      if (!val('city')) e.city = MSG.city;
      if (!val('state')) e.state = MSG.state;
      if (!/^\d{5}(-\d{4})?$/.test(val('zip'))) e.zip = MSG.zip;
      return e;
    }
    function show(errors) {
      ['legal_name', 'entity_type', 'ein', 'name', 'email', 'phone', 'address1', 'city', 'state', 'zip'].forEach(function (n) { setErr(n, errors[n]); });
      var names = Object.keys(errors);
      if (names.length) {
        var first = form.elements[names[0]];
        if (first) first.focus();
      }
      return names.length;
    }
    function say(kind, title, text, html) {
      result.hidden = false;
      result.className = 'whp-result' + (kind ? ' is-' + kind : '');
      result.innerHTML = '<b>' + esc(title) + '</b>' + (html || esc(text));
    }
    function esc(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    }

    form.addEventListener('input', function (ev) {
      var n = ev.target && ev.target.name;
      if (n && ev.target.getAttribute('aria-invalid') === 'true') { var e = check(); setErr(n, e[n]); }
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var errors = check();
      if (show(errors)) {
        say('err', 'Almost.', ' ' + Object.keys(errors).length + (Object.keys(errors).length === 1 ? ' field needs' : ' fields need') + ' a fix, marked below each one.');
        return;
      }
      if (d.sample === '1') {
        say('test', 'Sample only.', ' Everything checks out. This is the sample page, so nothing was sent.');
        return;
      }
      var payload = {};
      ['legal_name', 'entity_type', 'ein', 'store', 'name', 'email', 'phone', 'address1', 'city', 'state', 'zip', 'notes', 'website_hp'].forEach(function (n) { payload[n] = form.elements[n] ? form.elements[n].value : ''; });
      if (d.sig) { payload.customerId = d.customer; payload.acctEmail = d.acctEmail; payload.ts = d.ts; payload.sig = d.sig; }
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Sending...';
      fetch(d.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (out) {
          if (out && out.ok) {
            say(out.dryRun ? 'test' : '', out.dryRun ? 'Not sent yet.' : 'Sent.', ' ' + (out.message || ''));
            if (!out.dryRun) { Array.prototype.forEach.call(form.querySelectorAll('fieldset, .whp-field, .whp-hint, .whp-ap-send'), function (el) { el.hidden = true; }); }
            try { result.focus(); } catch (e) {}
            return;
          }
          if (out && out.errors) show(out.errors);
          if (out && out.code === 'sign_in') {
            say('err', 'Sign in instead.', '', ' ' + esc(out.message) + ' <a href="/account/login?return_url=' + encodeURIComponent(location.pathname) + '">Sign in</a>');
          } else {
            say('err', 'Not sent.', ' ' + ((out && out.message) || 'Something went wrong. Email info@insideoutcookie.com and Nick will sort it out.'));
          }
          try { result.focus(); } catch (e) {}
        })
        .catch(function () { say('err', 'Not sent.', ' We could not reach the bakery just now. Check your connection and try again.'); })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  // Sample page only: show the state named in the address, for example ?state=needs_ein.
  function sampleState() {
    var root = document.querySelector('[data-ioc-whp][data-ioc-demo="1"]');
    if (!root) return;
    var m = /[?&]state=([a-z_]+)/.exec(location.search);
    if (!m) return;
    var blocks = root.querySelectorAll('[data-whp-state]');
    var hit = Array.prototype.some.call(blocks, function (b) { return b.dataset.whpState === m[1]; });
    if (!hit) return;
    Array.prototype.forEach.call(blocks, function (b) { b.hidden = b.dataset.whpState !== m[1]; });
    root.dataset.iocState = m[1];
  }

  function boot() {
    sampleState();
    Array.prototype.forEach.call(document.querySelectorAll('[data-whp-form]'), init);
    Array.prototype.forEach.call(document.querySelectorAll('[data-whp-apply]'), initApply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
